// extracted by mini-css-extract-plugin
export default {"groupTitle":"ReportsGroupBody_groupTitle__gR1Ux","groupTotal":"ReportsGroupBody_groupTotal__Y-ZoM","groupBody":"ReportsGroupBody_groupBody__9hOdT"};